/**
 * Нужно ли показывать уведомление о заказе с учётом фильтра пиццерии на главной.
 * @param params.filterPizzeriaId — выбранная пиццерия или null (= все)
 * @param params.orderPizzeriaId — пиццерия заказа
 */
export const shouldNotifyNewOrder = (params: {
  filterPizzeriaId: number | null
  orderPizzeriaId: number
}): boolean => {
  const { filterPizzeriaId, orderPizzeriaId } = params
  if (filterPizzeriaId == null) {
    return true
  }
  return filterPizzeriaId === orderPizzeriaId
}
